export const ID_PREFIX_FOR_SHOOTING_ACTION = 'shoot_act'
export const ID_PREFIX_FOR_UNIT = 'unit'
export const ID_PREFIX_FOR_GOBLINS_TRAP = 'goblins_trap'
